import { ArrowRightIcon } from 'lucide-react'
import { useNavigate } from 'react-router'

import { useOnboardingStep } from 'components/hooks/employer_onboarding/useOnboardingStep'
import { Button, usePageTitle } from 'slab'

import { CenteredLayout } from '../CenteredLayout'

export function ResumePage () {
  usePageTitle('Welcome back')

  const navigate = useNavigate()
  const { resumeStep } = useOnboardingStep()

  const handleResume = () => {
    navigate(resumeStep)
  }

  return (
    <CenteredLayout verticallyCentered>
      <CenteredLayout.Header
        heading='Welcome back!'
        subheading='Looks like you need to finish setting your team up on Thatch.'
      />
      <CenteredLayout.Buttons>
        <Button
          variant='primary'
          onClick={handleResume}
          size='large'
          width='auto'
          rightIcon={ArrowRightIcon}
        >
          Resume where you left off
        </Button>
      </CenteredLayout.Buttons>
    </CenteredLayout>
  )
}
